import axios from "axios";
const BASE = "https://4mo22dhyk9.execute-api.ap-south-1.amazonaws.com";

export const transactionsToday = () => axios.get(`${BASE}/transactions/today`);
export const transactionsYesterday = () => axios.get(`${BASE}/transactions/yesterday`);
export const transactionsLast7 = () => axios.get(`${BASE}/transactions/last7`);
export const transactionsLast30 = () => axios.get(`${BASE}/transactions/last30`);

export const transactionsMonthlyRange = (body) =>
  axios.post(`${BASE}/transactions/dashboard/range`, body);
